"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "13", height: "13", viewBox: "0 0 13 13", className: "Icon element-resize-handle", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M1.707 13L13 1.707V.293L.293 13h1.414zm4 0L13 5.707V4.293L4.293 13h1.414zm4 0L13 9.707V8.293L8.293 13h1.414z", fill: "#777", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-resize-handle.js
// module id = 1799
// module chunks = 0